import { http } from "@/http";

export default {
  list(data, params) {
    return http.post("/celulares/relations/list", data, { params });
  },
  changeStatus(id, status) {
    return http.put(`/celulares/relations/${id}/status`, null, {
      params: { status },
    });
  },
  save(data) {
    return http.post("/celulares/relations", data);
  },
  update(id, data) {
    return http.put(`/celulares/relations/${id}`, data);
  },
  get(id) {
    return http.get(`/celulares/relations/${id}`);
  },
  queryDni(dni) {
    return http.get(`/celulares/relations/dni/${dni}`);
  },
  download(data) {
    return http.post("/celulares/relations/xlsx", data, { responseType: "blob" });
  },
};
